import React, { useEffect, useState } from "react"
import CommonTypo from "../../../components/CommonTypo"
import { Box } from "@mui/material"
import NewButton from "../../../components/NewButton"
import { makeStyles } from "@material-ui/core";
import clsx from "clsx";
import palette from "../../../theme/palette";
import { pxToRem } from "../../../theme/typography";
import shape from "../../../theme/shape";

const useStyles = makeStyles((theme) => ({
    customeRadioButton: {
        color: "var(--color-text-primary)",
        cursor: "pointer",
        height: "auto",
        gap: "24px",
        borderRadius: "12px",
        border: "2px solid var(--color-border)",
        padding: "16px",
        fontWeight: 400,
        fontSize: pxToRem(16),
        lineHeight: pxToRem(30),
        width: "100%",
        textAlign: "left"
    },
    customeRadioButtonActive: {
        border: "2px solid var(--color-new-main)",
        fontWeight: 500,

    },
}))

const Step2 = ({ setNextStep, setPreviousStep, setStatus, userIdentificationStatus }) => {
    const classes = useStyles()

    const [activeStatusNo, setActiveStatusNo] = useState(userIdentificationStatus);
    const [activeStatus, setActiveStatus] = useState(false);
    const [userStatus, setUserStatus] = useState("");
    const getUserStatus = (status: string) => {
        if (status === "yes") {
            setActiveStatus(true);
            setActiveStatusNo(false);
        } else {
            setActiveStatus(false);
            setActiveStatusNo(true);
        }
        setUserStatus(status);
        setStatus(status)
    };
    useEffect(() => {
        if (userIdentificationStatus === "yes") {
            setUserStatus(userIdentificationStatus)
        }
        if (userIdentificationStatus === "no") {
            setUserStatus(userIdentificationStatus)
        }
    }, [userIdentificationStatus])
    console.log("userStatus", userStatus);

    return <>
        <Box display={"flex"} flexDirection={"column"} gap={"4px"} alignItems={"center"}>
            <CommonTypo size={32} fontWeight={700} color="var(--color-text-primary)" lineHeight={36}>Are you new to tracking?</CommonTypo>
            <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)" lineHeight={22}>Tell us if you did track before using different tools</CommonTypo>
        </Box>
        <Box sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: "8px",
            borderRadius: "12px",
            flexDirection: "column",
            width: "100%",
            flexWrap: "nowrap"
        }}>
            <div
                className={`${userStatus === "yes"
                    ? clsx(
                        classes.customeRadioButton,
                        classes.customeRadioButtonActive
                    )
                    : classes.customeRadioButton
                    }`}
                onClick={() => getUserStatus("yes")}
            >
                Yes, I’m new to tracking
            </div>
            <div
                className={`${userStatus === "no"
                    ? clsx(
                        classes.customeRadioButton,
                        classes.customeRadioButtonActive
                    )
                    : classes.customeRadioButton
                    }`}
                onClick={() => getUserStatus("no")}
            >
                No, I breath data and tracked several aspects of my life before
            </div>
        </Box >
    </>
}

export default Step2